export enum MilestoneState {
  New,
  PaymentRequested,
  Completed,
}

export enum MilestoneEditState {
  display,
  editing,
}

// type Mutation {
// # Throw errors if creating milestone with due date before completed milestones
//   createMilestones(input: [CreateMilestoneInput!]): Milestone!
// # Throw errors when trying to edit after state is locked, ie has payment request
//   updateMilestone(input: [UpdateMilestoneInput!]): Milestone!
// # Throw error if milestone does not exists or lack of authorization
//   deleteMilestone(input: [DeleteMilestoneInput!]): Milestone!
// }

interface CreateMilestoneInput {
  name: string
  purchaseOrderNumber: string
  dueDate: string
  amount: number
  hire: string
}

interface UpdateMilestoneInput {
  id: string // Milestone id
  name: string
  purchaseOrderNumber: string
  dueDate: string
  amount: number
}

interface DeleteMilestoneInput {
  id: string
}

export interface MilestoneGql {
  id: string
  name: string
  purchaseOrderNumber: string
  state: MilestoneState
  currentDetails: MilestoneDetailGql
  // details: MilestoneDetailGql[]
}

export interface MilestoneDetailGql {
  id: string
  dueDate: string
  amount: string

  // milestone: MilestoneGql
}
